import { render, staticRenderFns } from "./worth.vue?vue&type=template&id=1a34f07c&scoped=true&"
import script from "./worth.vue?vue&type=script&lang=js&"
export * from "./worth.vue?vue&type=script&lang=js&"
import style0 from "./worth.vue?vue&type=style&index=0&id=1a34f07c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a34f07c",
  null
  
)

export default component.exports